import React, { useCallback, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import translate from '../../../commonComponents/translate';
import TabAcademyPerformance from './performance/TabAcademyPerformance';
import performanceProp from '../propTypes/performanceProp';
import chartsProp from '../propTypes/chartsProp';
import certificateProp from '../../academy/propTypes/certificateProp';
import TabPerformPerformance from './performance/TabPerformPerformance';
import trophyProp from '../../journey/propTypes/trophyProp';
import Notifications from '../../../services/notifications';
import LoggedUserContext from '../../../contextProviders/LoggedUserContext';
import withCSRF from '../../../commonComponents/withCSRF';
import { compose } from '../../../services/utilityFunctions';

function Performance({ t, certificates, customTrophies, _csrf }) {
  const { loggedUser } = useContext(LoggedUserContext);
  const [tab, setTab] = useState('academy');
  const [stats, setStats] = useState({
  });

  const getStats = useCallback(async () => {
    try {
      const { data: responsePerformance } = await axios.get(`/api/user/${loggedUser._id}/performance`, {
        headers: {
          'Accept-Version': '1.0.0',
          'X-Gamification-API': 'Games',
          'X-CSRF-Token': _csrf,
          _csrf,
        },
      });
      const { data: responseStats } = await axios.get(`/api/user/${loggedUser._id}/stats`, {
        params: {
          populate: [
            'game',
            'manager',
            'course',
            'journey',
            'user',
            'marketCommissionReport',
          ],
        },
        headers: {
          'Accept-Version': '1.0.0',
          'X-Gamification-API': 'Games',
        },
      });
      console.log('*response', responsePerformance.data);
      console.log('*TEEST', {
        performance: responsePerformance.data,
        charts: responseStats.data,
      });
      setStats({
        performance: responsePerformance.data,
        charts: responseStats.data,
      });
    } catch (err) {
      console.error(err);
      Notifications.showErrorFromRequest(err);
    }
  }, [loggedUser]);

  useEffect(() => {
    getStats();
  }, [getStats]);
  return (
    <div className="performance-container">
      <div className="row performance-tabs">
        <div className="col-lg-2 col-3 performance-tabs-academy">
          <button
            type="button"
            onClick={() => { setTab('academy'); }}
            className={tab === 'academy' ? 'active' : ''}
          >
            {t('profile.performance.tab.academy')}
          </button>
        </div>
        <div className="col-lg-2 col-3 performance-tabs-perform">
          <button
            type="button"
            onClick={() => { setTab('perform'); }}
            className={tab === 'perform' ? 'active' : ''}
          >
            {t('profile.performance.tab.perform')}
          </button>
        </div>
        {/* TODO: IMPLEMENT IN THE FUTURE */}
        {/* <div className="col-lg-3 col-3 performance-tabs-marketplace"> */}
        {/*  <button */}
        {/*    type="button" */}
        {/*    onClick={() => { setTab('marketplace'); }} */}
        {/*    className={tab === 'marketplace' ? 'active' : ''} */}
        {/*  > */}
        {/*    {t('profile.performance.tab.marketplace')} */}
        {/*  </button> */}
        {/* </div> */}
      </div>
      <div className="performance-tabs-content">
        {tab === 'academy' && stats.performance && stats.charts &&
          <div>
            <TabAcademyPerformance t={t} stats={stats} certificates={certificates} />
          </div>
        }
        {tab === 'perform' && stats.performance && stats.charts &&
        <div>
          <TabPerformPerformance t={t} stats={stats} certificates={certificates} customTrophies={customTrophies} />
        </div>
        }
        {tab === 'marketplace' && // TODO: IMPLEMENT IN THE FUTURE
          <div />
        }
      </div>
    </div>
  );
}

Performance.propTypes = {
  t: PropTypes.func.isRequired,
  stats: PropTypes.shape({
    performance: PropTypes.shape(performanceProp.propType),
    charts: PropTypes.shape(chartsProp.propType),
  }).isRequired,
  certificates: PropTypes.arrayOf(PropTypes.shape(certificateProp.propType))
    .isRequired,
  customTrophies: PropTypes.arrayOf(PropTypes.shape(trophyProp.propType))
    .isRequired,
  _csrf: PropTypes.string.isRequired,
};

export default compose(translate, withCSRF)(Performance);
